import { boot } from 'quasar/wrappers'
import { createI18n } from 'vue-i18n'
import messages from 'src/i18n'

const datetimeFormats = {
  'en-us': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  'it-it': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false
    }
  }
}

const i18n = createI18n({
  legacy: false, // usa Composition API
  locale: 'it-it',
  fallbackLocale: 'en-us',
  allowComposition: true,
  messages,
  datetimeFormats,
  globalInjection: true, // permette l'uso diretto di $t senza `useI18n`
})

export default boot(({ app }) => {
  app.use(i18n)
})

export { i18n }
